<a
  #popoverRef="bs-popover"
  #popoverTrigger
  cignaButton="link inline {{
    underlineStyle !== 'link' ? underlineStyle : ''
  }}"
  [placement]="placement"
  [adaptivePosition]="hasAdaptivePosition"
  container="body"
  containerClass="cigna-popover-layout {{ containerClass }}"
  [popover]="popover"
  [outsideClick]="true"
  [isOpen]="isOpen"
  (onHidden)="hide()"
  tabindex="0"
  [attr.role]="!role ? 'button' : null"
  [attr.aria-label]="areaLabelText"
>
  <ng-content></ng-content>
</a>

<ng-template #popover>
  <div
    data-test-id="popover-content"
    #popoverContent
    [id]="popoverId"
    (keydown.escape)="hide(); restoreFocus()"
    aria-live="polite"
    role="status"
  >
    <ng-container
      (click)="$event.preventDefault()"
      [ngTemplateOutlet]="content"
      [ngTemplateOutletContext]="contentContext"
    >
    </ng-container>
    <div *ngIf="keepOpen" class="text-right">
      <button
        #closeButton
        cignaButton="link inline"
        (click)="hide()"
        (keydown.tab)="focusFirstElement($event)"
        (keydown.enter)="hide(); restoreFocus()"
        (keydown.space)="hide(); $event.preventDefault(); restoreFocus()"
        data-test-id="close-popup"
      >
        {{ close }}
      </button>
    </div>
  </div>
</ng-template>
